module.exports = __webpack_public_path__ + "static/media/line.ec3078b8.svg";